import Tools from "../../ts/Tools"
import EZAlert from "../popups/EZAlert";

const MY_COOKIE_NAME = "ez_bookmark_data";
const BOOKMARK_MAX: number = 15;

export default class BookmarkCookie
{
  private static _bookmarkDic: {[key:string]: boolean}
  private static _bookmarkList: string[];

  private static _isInit:boolean = false;

  static init()
  {
    if(!Tools.isLocalStorageAvailable()) return;
    if(this._isInit) return;
    this._isInit = true;

    this._bookmarkDic = Tools.getLocalStorageObj(MY_COOKIE_NAME);
    this._generateList();    

    // console.log(this._bookmarkDic);
  }

  static isProductBookmarked(productId: string)
  {
    return Boolean(this._bookmarkDic[productId]);
  }

  static override(dic: {[key:string]: boolean})
  {
    this._bookmarkDic = dic;
    this._update();
  }

  static save(productId: string)
  {
    if(this._bookmarkList.length >= BOOKMARK_MAX)
    {
      EZAlert.alert("超出數量上限", `最多只能收藏 ${BOOKMARK_MAX} 筆行程`);
      return false;
    }

    this._bookmarkDic[productId] = true;
    this._update();

    return true;
  }

  static delete(productId: string)
  {
    delete this._bookmarkDic[productId];
    this._update();
  }

  static getList()
  {
    return this._bookmarkList;
  }

  private static _update()
  {
    this._generateList();
    Tools.saveLocalStorageObj(MY_COOKIE_NAME, this._bookmarkDic);
  }

  private static _generateList()
  {
    this._bookmarkList = [];

    for(let key in this._bookmarkDic)
    {
      this._bookmarkList.push(key);
    }

    // console.log(this._bookmarkList.length);    
  }
}